import { endpoint } from "@services/api.services";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import IndustryForm from "./form/industry.form";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { IndustryAlliesData } from "@utils/interface/journey.interface";
type Props = {};

const index: React.FC<Props> = ({}) => {
  const pathname = usePathname();
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryData<IndustryAlliesData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },
    endpoint: endpoint["industryallies"],
    key: `${pathname}-listing`,
  });
  const columns = ColumnList();

  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        showOrientation
        inject_ui_table_actions
        grid={
          <GeneralCard type="industry" onDelete={() => {}} onEdit={() => {}} showCheck />
        }
        refetch={refetch}
        endpoint={endpoint["industryallies"]}
        form={<IndustryForm />}
        columns={columns}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
        }}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
